import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['fileName']

  fileSelected(event) {
    const file = event.target.files[0]
    if (file && this.hasFileNameTarget) {
      this.fileNameTarget.textContent = `Selected: ${file.name}`
    }
  }
}